// extracted by mini-css-extract-plugin
module.exports = {"btnSaved":"buttonSaveProjectPage_btnSaved__16SjP"};
    if(module.hot) {
      // 1790670316531
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  